import { stringify } from "flatted";
import { errorHandler } from "../utils/errorHandler";

type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

interface RequestOptions {
  method: HttpMethod;
  headers: Record<string, string>;
  body?: string | FormData;
}

export async function makeRequest(
  method: HttpMethod,
  url: string,
  apiKey: string,
  queryParams: Record<string, string> = {},
  jsonData: Record<string, unknown> | null = null,
  files: File[] | null = null,
  data: FormData | null = null
): Promise<any> {
  const headers: Record<string, string> = {
    MiraAuthorization: apiKey,
    "Content-Type": files ? "multipart/form-data" : "application/json",
  };

  const queryString = new URLSearchParams(queryParams).toString();
  const fullUrl = queryString ? `${url}?${queryString}` : url;

  const requestOptions: RequestOptions = {
    method,
    headers,
    ...(jsonData && { body: stringify(jsonData) }), // Use flatted stringify
    ...(data && { body: data }),
  };

  if (files) {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    requestOptions.body = formData;
    delete headers["Content-Type"];
  }

  try {
    const response = await fetch(fullUrl, requestOptions);
    const contentType = response.headers.get("content-type");

    if (!response.ok) {
      const errorMessage = contentType?.includes("application/json")
        ? await response.json()
        : await response.text();
      throw new Error(
        `Response status: ${response.status}, detail: ${errorMessage}`
      );
    }

    return contentType?.includes("application/json")
      ? await response.json()
      : response.text();
  } catch (error) {
    return errorHandler(error);
  }
}
